import type { DeliveryDetailDto, GetDeliveriesParams, UpdateDeliveryDto } from '@repo/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getDeliveries, getDeliveryDetail, patchDelivery } from '@/api/delivery';

export const useDelivery = (params: GetDeliveriesParams) => {
  return useQuery({
    queryKey: ['delivery', params],
    queryFn: () => getDeliveries(params),
  });
};

export const useDeliveryDetail = (id: number | null) => {
  return useQuery<DeliveryDetailDto>({
    queryKey: ['deliveryDetail', id],
    queryFn: () => {
      if (id === null) {
        throw new Error('배송 ID가 없습니다.');
      }
      return getDeliveryDetail(id);
    },
    enabled: id !== null,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useUpdateDelivery = (id: number | null) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: UpdateDeliveryDto) => {
      if (id === null) {
        throw new Error('배송 ID가 없습니다.');
      }
      return patchDelivery(id, dto);
    },
    onSuccess: (updated) => {
      queryClient.setQueryData(['deliveryDetail', updated.id], updated);
      void queryClient.invalidateQueries({ queryKey: ['delivery'] });
    },
  });
};
